
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Calendar from '../components/Calendar.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
   {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/inventory',
    name: 'Inventory',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/Inventory.vue'),
  },
  {
    path: '/orders',
    name: 'orders',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../views/Orders.vue'),
  },
  {
    path: '/sales',
    name: 'sales',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../views/Sales.vue'),
  },
  {
    path: '/stocktake',
    name: 'stocktake',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../views/StockTake.vue'),
  },
  {
    path: '/order/:id/info',
    name: 'order-info',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../views/inventory/OrderInfo.vue'),
  },
  {
    path: '/part/:id',
    name: 'Part',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/inventory/Part.vue'),
    children: [
      {
        // CustomerInfo will be rendered inside customer's <router-view>
        // when /customer/:id/info is matched
        path: 'info',
        name: "part-info",
        component: () => import('../views/inventory/PartInfo.vue')
      },
      {
        // CustomerInfo will be rendered inside customer's <router-view>
        // when /customer/:id/info is matched
        path: 'references',
        name: "part-references",
        component: () => import('../views/inventory/PartReferences.vue')
      },
      {
        // CustomerInfo will be rendered inside customer's <router-view>
        // when /customer/:id/info is matched
        path: 'orders',
        name: "part-orders",
        component: () => import('../views/inventory/PartOrders.vue')
      },
      {
        // CustomerInfo will be rendered inside customer's <router-view>
        // when /customer/:id/info is matched
        path: 'checkouts',
        name: "part-checkouts",
        component: () => import('../views/inventory/PartCheckouts.vue')
      },
    ]
  },
  {
    path: '/oldinventory',
    name: 'OldInventory',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/InventoryOld.vue')

  },
  {
    path: '/repairs',
    name: 'Repairs',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/Repairs.vue')

  },
  {
    path: '/debits',
    name: 'Debits',
    component: () => import('../views/Debits.vue')

  },
  {
    path: '/iso',
    name: 'Isologismos',
    component: () => import('../views/Transactions.vue')

  },
  {
    path: '/expenses',
    name: 'Expenses',
    component: () => import('../views/Expenses.vue')

  },
   {
    path: '/aging',
    name: 'Aging',
    component: () => import('../views/AgedAccounts.vue')

  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/Dashboard.vue')

  },
  {
    path: '/invoices',
    name: 'Invoices',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inventory" */ '../views/Invoices.vue'),

  },
  {
    path: '/supinvoices',
    name: 'SupplierInvoices',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/SupplierInvoices.vue'),

  },
  {
      path: '/preorders',
      component: () => import('../views/Preorders.vue'),
      name: "preorders-list",
  },
  {
    path: '/invoice/details/:invoid',
    name: 'Invoice',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "invoices" */ '../views/InvoiceInfo.vue')

  },
  {
    path: '/customers',
    name: 'Customers',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customers" */ '../views/Customers.vue'),

  },
   {
      path: '/customer/:id',
      component: () => import('../views/customers/Customer.vue') ,
      children: [
        {
          // CustomerInfo will be rendered inside customer's <router-view>
          // when /customer/:id/info is matched
          path: 'info',
          name: "customer-info",
          component: () => import('../views/customers/CustomerInfo.vue')
        },
        {
          path: 'invoices',
          name: "customer-invoices",
          component: () => import('../views/customers/CustomerInvoices.vue')
        },
        {
          path: 'quotes',
          name: "customer-quotes",
          component: () => import('../views/customers/CustomerQuotes.vue')
        },
        {
          path: 'vehicles',
          name: "customer-vehicles",
          component: () => import('../views/customers/CustomerVehicles.vue')
        },
         {
          path: 'line-items',
          name: "customer-line-items",
          component: () => import('../views/customers/CustomerLineItems.vue')
        },
        {
          path: 'repair-items',
          name: "customer-repair-items",
          component: () => import('../views/customers/CustomerRepairItems.vue')
        },
        {
          path: 'customer-preorders',
          name: "customer-preorders",
          component: () => import('../views/customers/CustomerPreOrders.vue')
        },
         {
          path: 'repairs',
          name: "customer-repairs",
          component: () => import('../views/customers/CustomerRepairs.vue')
        },
         {
          path: 'balance',
          name: "customer-balance",
          component: () => import('../views/customers/CustomerBalance.vue')
        },
        {
          path: 'sales',
          name: "customer-sales",
          component: () => import('../views/customers/CustomerSales.vue')
        },
        {
          path: 'documents',
          name: "customer-documents",
          component: () => import('../views/customers/CustomerDocuments.vue')
        },
         {
          path: 'contacts',
          name: "customer-contacts",
          component: () => import('../views/customers/CustomerContacts.vue')
        },
      ]
    },
  {
      path: '/quotes',
      component: () => import('../views/Quotes.vue'),
      name: "quotes-list",
  },
  {
      path: '/quote/create',
      component: () => import('../views/quotes/Create.vue'),
      name: "quote-create",
  },
   {
     path: '/quote/edit/:quoteid',
      name: "quote-edit",
      component: () => import('../views/quotes/Edit.vue')
    },
  {
  path: '/books',
  name: 'Books',
  component: () => import('../views/Books.vue')

},
  {
    path: '/books/:id',
  component: () => import('../views/books/Book.vue'),
      children: [
        {
          path: 'info',
          name: "book-info",
          component: () => import('../views/books/BookInfo.vue')
        },
         {
          path: 'repairs',
          name: "book-repairs",
          component: () => import('../views/books/BookRepairs.vue')
        },
        {
          path: 'crepairs',
          name: "book-customer-repairs",
          component: () => import('../views/books/CustomerRepairs.vue')
        },
        {
          path: 'documents',
          name: "book-customer-documents",
          component: () => import('../views/customers/CustomerDocuments.vue')
        },
        {
          path: 'quotes',
          name: "quotes-info",
          component: () => import('../views/customers/CustomerQuotes.vue')
        },
         {
          path: 'vehicles',
          name: "book-vehicles",
          component: () => import('../views/books/BookVehicles.vue')
        },
        {
          path: 'repair-items',
          name: "book-repair-items",
          component: () => import('../views/books/BookRepairItems.vue')
        },
        {
          path: 'lineitems',
          name: "quote-items",
          component: () => import('../views/customers/CustomerQuoteItems.vue')
        },
         {
          path: 'contacts',
          name: "book-contacts",
          component: () => import('../views/books/BookContacts.vue')
        }
      ]

},
   {
    path: '/vehicles',
    name: 'vehicles',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "repairs" */ '../views/Vehicles.vue'),

  },
   {
    path: '/utils',
    name: 'utilities',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "utils" */ '../views/Utilities.vue'),

  },
   {
     path: '/repair/edit/:repairId',
    name: 'edit-repair',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/repairs/Edit.vue'),

  },
   {
     path: '/repair/preorder/:repairId',
    name: 'repair-preorders',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/repairs/Preorder.vue'),

  },
  {
    path: '/vehicle/details/:vehicle',
    name: 'Vehicle',
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "repairs" */ '../views/VehicleInfo.vue')

  },
  {
  path: '/distributors',
  name: 'Distributors',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "suppliers" */ '../views/Distributors.vue')

},
   {
      path: '/distributor/:id',
      component: () => import('../views/distributors/Distributor.vue') ,
      children: [
        {
          path: 'info',
          name: "distributor-info",
          component: () => import('../views/distributors/DistributorInfo.vue')
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'invoices',
          name: "distributor-invoices",
          component: () => import('../views/distributors/DistributorInvoices.vue')
        },
        {
          path: 'aade',
          name: "distributor-aade-invoices",
          component: () => import('../views/distributors/DistributorAadeInvoices.vue')
        },
         {
          path: 'accounts',
          name: "distributor-accounts",
          component: () => import('../views/distributors/Accounts.vue')
        },
        {
          path: 'orders',
          name: "distributor-orders",
          component: () => import('../views/distributors/DistributorOrders.vue')
        },
        {
          path: 'preorders',
          name: "distributor-preorders",
          component: () => import('../views/distributors/DistributorPreOrders.vue')
        },
        {
          path: 'sales',
          name: "distributor-sales",
          component: () => import('../views/distributors/DistributorSales.vue')
        },
        {
          path: 'balance',
          name: "distributor-balance",
          component: () => import('../views/distributors/DistributorBalance.vue')
        },
        {
          path: 'monthly-purchases',
          name: "distributor-purchases",
          component: () => import('../views/distributors/DistributorPurchases.vue')
        },
      ]
    },
    {
        path: '/distributor/order/:invoiceId',
        name: "distributor-order-checkin",
        component: () => import('../views/distributors/OrderCheckin.vue')
      },
{
  path: '/docs',
  name: 'docs',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../views/Search.vue')

},
{
  path: '/user/profile',
  name: 'profile',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../views/user/User.vue')

},
{
  path: '/aade',
  name: 'aade',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../views/Aade.vue'),
  children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: 'purchases',
          name: "aade-purchases",
          component: () => import('../views/aade/AadePurchases.vue')
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'sales',
          name: "aade-sales",
          component: () => import('../views/aade/AadeSales.vue')
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'clients',
          name: "aade-client-book",
          component: () => import('../views/aade/AadeDigitalClientsList.vue')
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'charts',
          name: "aade-charts",
          component: () => import('../views/aade/AadeCharts.vue')
        }
      ]

},
{
  path: '/sap',
  name: 'sap',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../views/Sap.vue')

},
{
  path: '/income',
  name: 'income',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../views/Income.vue')

},
{
  path: '/appointments',
  name: 'appointments',
  component: () => import('../views/Appointments.vue'),
},
{
  path: '/login',
  name: 'login',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "inventory" */ '../login/LoginPage.vue')

},
// otherwise redirect to home
{ path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/about', '/', '/invoices', '/customers', '/sap'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next({
    path: '/login',
    query: { redirect: to.fullPath }
      });
  }

  next();
})

export default router
